import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import Map from '../../components/google/maps/Map';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { selectors } from '../../store/dux/field-boundary-management-dux';
import { useContext } from './context';
import { useLayers } from './use-layers';
import { useBounds } from './use-bounds';
import { useMapClick } from './use-map-click';

export function FieldBoundaryManagementMap() {
  const growerId = useSelector(growerSelectors.selectedId);
  const selectedFields = useSelector(selectors.selectedFields);
  const { tab, setMap, selectedFeatures } = useContext();
  const onMapClick = useMapClick();
  const layers = useLayers();
  const bounds = useBounds();
  const isIrrigation = /IRRIGATION/i.test(tab);

  const selectedMapFeatures = useMemo(
    () => ({
      boundary: isIrrigation ? [] : selectedFields,
      'boundary-uncertified': isIrrigation ? [] : selectedFields,
      'irrigation-boundary': isIrrigation ? selectedFeatures : [],
    }),
    [isIrrigation, selectedFeatures, selectedFields],
  );

  return (
    <Map
      pkRemovalEnabled
      onLoad={setMap}
      layers={layers}
      bounds={bounds}
      filters={{ growerId }}
      onClick={onMapClick}
      selectedFeatures={selectedMapFeatures}
    />
  );
}
